<span [class]="'icon icon-' + icon" *ngIf="icon"></span>
<span class="text">
  <ng-content select="strong"></ng-content>
  <ng-content></ng-content>
</span>
